import * as httpleaseAsap from 'httplease-asap';
import { decodeAsapPrivateKeyDataUri } from './decode';

export type AsapClaimsPartial = {
  readonly issuer: string;
  readonly keyId: string;
  readonly privateKey: string;
};

export type AsapClaims = AsapClaimsPartial & {
  readonly subject?: string;
  readonly audience: string;
};

export function generateAsapHeader({
  issuer,
  audience,
  keyId,
  privateKey,
  subject
}: AsapClaims): string {
  if (privateKey.includes('data:application/pkcs8')) {
    const {
      keyId: uriKeyId,
      privateKey: uriPrivateKey
    } = decodeAsapPrivateKeyDataUri(privateKey);

    keyId = uriKeyId;
    privateKey = uriPrivateKey;
  }

  const jwtConfig = {
    privateKey,
    issuer,
    keyId,
    audience,
    subject
  };

  const authHeaderGenerator = httpleaseAsap.createAuthHeaderGenerator(
    jwtConfig
  );

  return authHeaderGenerator();
}
